
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import Link from 'components/Link'
import SiteSelector from 'components/SiteSelector'
import OnboardingProgress from 'components/OnboardingWizard/OnboardingProgress'
import isEqual from 'lodash/isEqual'
import {isIE, whichBrowserVersion} from 'sniff-fns'
import TopbarDropdown, {TopbarDropdownItem} from './Dropdown'

export default class Topbar extends React.Component {
  static propTypes = {
    sites: PropTypes.arrayOf(PropTypes.shape({
      domain: PropTypes.string,
      id: PropTypes.string
    })),
    onSelectSite: PropTypes.func,
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    selectedSites: PropTypes.array,
    user: PropTypes.object,
    onLogout: PropTypes.func,
    onEditProfile: PropTypes.func,
    onEditSites: PropTypes.func,
    freeMerchant: PropTypes.bool,
    demoUser: PropTypes.bool,
    openNotify: PropTypes.func,
    notifyNumber: PropTypes.number,
    adminUser: PropTypes.bool
  }

  static defaultProps = {
    notifyNumber: 0,
    sites: []
  }

  static contextTypes = {
    permissions: PropTypes.object,
    crossSiteMode: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      forceCloseDropdown: false
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const crossSiteChanged = this.context.crossSiteMode !== nextContext.crossSiteMode
    const currentSiteChanged = this.props.currentSite !== nextProps.currentSite
    const selectedSitesChanged = !isEqual(this.props.selectedSites, nextProps.selectedSites)

    this.setState({
      forceCloseDropdown: crossSiteChanged || currentSiteChanged || selectedSitesChanged
    })
  }

  render() {
    if (this.props.children) return <div className='topbar'>{this.props.children}</div>

    return (
      <div className='topbar'>
        {this.renderSiteSelector()}
        <div className='topbar_announcements'>
          {this.renderUpgradeNote()}
        </div>
        {this.renderOnboardingProgress()}
        {this.renderNotifyIcon()}
        {this.renderEditProfile()}
      </div>
    )
  }

  renderOnboardingProgress() {
    return (
      <OnboardingProgress />
    )
  }

  renderNotifyIcon() {
    const {openNotify} = this.props
    return (
      <div className='notify_icon' onClick={openNotify} >
        <Icon name='bell' size='22px' />
        {this.renderNotifyNumber()}
      </div>
    )
  }

  renderNotifyNumber() {
    const {notifyNumber} = this.props
    const number = notifyNumber > 9 ? '9+' : notifyNumber
    if (number == 0) return ''
    return (
      <div className='notify_number'>{number}</div>
    )
  }
  renderEditProfile() {
    const {user, onLogout, onEditProfile} = this.props
    const {permissions} = this.context
    const userName = user && (user.name || user.firstName)
    const allowEditProfile = permissions.show.includes('@features/editProfile')

    return (
      <TopbarDropdown
        className='topbar_profile-dropdown'
        title={userName || '...'}
        iconOnTheLeft='chevron'
      >
        {allowEditProfile ? <TopbarDropdownItem onClick={onEditProfile}>Edit Profile</TopbarDropdownItem> : null}
        <TopbarDropdownItem onClick={onLogout} className='topbar_profile-dropdown_logout'>
          <Icon name='turn-off' size='14px' className='topbar_profile-dropdown_logout_icon' />
          Logout
        </TopbarDropdownItem>
      </TopbarDropdown>
    )
  }

  renderSiteSelector() {
    const {sites, onSelectSite, onEditSites, selectedSites} = this.props
    const {crossSiteMode} = this.context
    const {forceCloseDropdown} = this.state

    if (sites.length > 1) {
      return (
        <TopbarDropdown
          title={this.renderTitle()}
          className='topbar_site-select'
          iconOnTheRight='chevron'
          fullHeight
          forceClose={forceCloseDropdown}
        >
          <SiteSelector
            sites={sites}
            selectedSites={selectedSites}
            onSelectSite={onSelectSite}
            crossSiteMode={crossSiteMode}
            onSelectMultiple={onEditSites}
          />
        </TopbarDropdown>
      )
    } else {
      return null
    }
  }

  renderTitle() {
    const {currentSite, selectedSites} = this.props
    const {crossSiteMode} = this.context

    if (crossSiteMode) {
      return (
        <div className='topbar_aggregated'>
          Aggregated account
          <br />
          <span className='topbar_aggregated_selected'>
            {selectedSites.length} sites selected
          </span>
        </div>
      )
    } else {
      return currentSite ? currentSite.name : '...'
    }
  }

  renderUpgradeNote() {
    const {freeMerchant, demoUser, adminUser} = this.props

    if (adminUser) {
      return (<div className='topbar_announcements_upgrade-free'>
        <Icon name='small-wizard' width='33px' height='43px' />
        <Tooltip
          className='topbar_announcements_upgrade-free_tooltip'
          place='right'
          style='red'
        >
          Admin mode
        </Tooltip>
      </div>)
    }

    if (demoUser) {
      return (
        <div className='topbar_announcements_upgrade-free'>
          <a href={`${__WWW_URL__}pricing`}>
            <Icon name='small-wizard' width='33px' height='43px' />
            <Tooltip
              className='topbar_announcements_upgrade-free_tooltip'
              place='right'
              style='orange'
            >
              You’re currently viewing demo data. Want to see your own sites data? Get started for free now!
            </Tooltip>
          </a>
        </div>
      )
    }

    if (isIE && whichBrowserVersion <= 10) {
      return (<div className='topbar_announcements_upgrade-free'>
        <Icon name='small-wizard' width='33px' height='43px' />
        <Tooltip
          className='topbar_announcements_upgrade-free_tooltip'
          place='right'
          style='orange'
        >
          You{"'"}re using old version of Internet Explorer, it{"'"}s better to upgrade your browser.
        </Tooltip>
      </div>)
    }

    if (freeMerchant) {
      return (
        <div className='topbar_announcements_upgrade-free'>
          <Link to='/settings'>
            <Icon name='small-wizard' width='33px' height='43px' />
            <Tooltip
              className='topbar_announcements_upgrade-free_tooltip'
              place='right'
              style='orange'
            >
              Upgrade to reach your potential
            </Tooltip>
          </Link>
        </div>
      )
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./client/components/Topbar/index.js